import {useState} from "react";
import {salvarMensagem} from "../../services/mensagemService";
import {toast} from "react-hot-toast";
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';

// Customizar tags HTML geradas pelo Quill
const bold = Quill.import('formats/bold');
bold.tagName = 'b';
Quill.register(bold, true);

const italic = Quill.import('formats/italic');
italic.tagName = 'i';
Quill.register(italic, true);

// Custom blot para quebras de linha com <br>
const Embed = Quill.import('blots/embed');
class SoftLineBreakBlot extends Embed {
    static blotName = 'softbreak';
    static tagName = 'br';
}
Quill.register(SoftLineBreakBlot, true);

// Handler para quebras de linha
function shiftEnterHandler(this: any, range: any) {
    this.quill.insertEmbed(range.index, 'softbreak', true, 'user');
    this.quill.setSelection(range.index + 1, 'silent');
}

type CadastrarMensagemProps = {
    addToItemsAfterCreate: (itemCriado: any) => any;
}

const modules = {
    toolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        ['link'],
        ['clean']
    ],
    keyboard: {
        bindings: {
            enter: {
                key: 'Enter',
                handler: shiftEnterHandler
            },
            shiftEnter: {
                key: 'Enter',
                shiftKey: true,
                handler: shiftEnterHandler
            }
        }
    }
}

function CadastrarMensagem(props: CadastrarMensagemProps) {
    const [titulo, setTitulo] = useState<string | undefined>(undefined)
    const [descricao, setDescricao] = useState<string | undefined>(undefined)
    const [conteudo, setConteudo] = useState<string | undefined>(undefined)
    const [erros, setErros] = useState<any>({})
    const [submited, setSubmited] = useState<boolean>(false)

    const [loading, setLoading] = useState<boolean>(false)

    async function handleSubmit(e: any) {
        e.preventDefault()
        setSubmited(true)
        if(validarDados()) {
            return;
        }
        const conteudoLimpo = conteudo?.replace(/<\/?p>/g, '').replace(/<\/?div>/g, '') || ""
        let mensagem = {
            "titulo": titulo,
            "descricao": descricao,
            "conteudo": conteudoLimpo
        }
        setLoading(true)
        await salvarMensagem(mensagem)
            .then((response) => {
                toast.success("Mensagem cadastrada com sucesso", {
                    icon: "🎉",
                    duration: 4000
                })
                let itemCriado = response.payload
                props.addToItemsAfterCreate(itemCriado)
                resetarFormulario()
                if(e.nativeEvent.submitter.name === "save-and-close") {
                    document.getElementById("modal-button-close")!.click()
                }
            })
            .finally(() => {
                setLoading(false)
            })
    }

    function validarDados(): boolean  {
        let erros = {};

        if(titulo == null || titulo == undefined || titulo.trim() == "") {
            erros = {
                ...erros,
                "titulo": "O campo Titulo é obrigatório"
            };
        }
        const conteudoLimpo = conteudo?.replace(/<[^>]*>/g, '').trim() || ""
        if(conteudoLimpo === "") {
            erros = {
                ...erros,
                "conteudo": "O campo Mensagem é obrigatório"
            };
        }

        setErros(erros)

        if(Object.keys(erros).length > 0) {
            return true;
        } else {
            return false;
        }
    }

    function checkHasError(campo: string) {
        if(submited) {
            if(Object.hasOwn(erros, campo)) {
                return "is-invalid"
            } else {
                return "is-valid"
            }
        } else {
            return ""
        }
    }

    function resetarFormulario() {
        setTitulo(undefined)
        let titulo = (document.getElementById("titulo") as HTMLInputElement)
        titulo.value = ""
        setDescricao(undefined)
        let descricao = (document.getElementById("descricao") as HTMLInputElement)
        descricao.value = ""
        setConteudo("")
        setSubmited(false)
        setErros({})
    }

    return (
        <>
            <form onSubmit={(e) => handleSubmit(e)} noValidate>
                <div className="mb-3">
                    <label htmlFor="titulo" className="form-label">Titulo</label>
                    <label className={"text-muted ms-1"}><small>(Obrigatório)</small></label>
                    <input
                        type="text"
                        className={`form-control ${checkHasError("titulo")}`}
                        id="titulo"
                        onChange={(e) => setTitulo(e.target.value)}
                        required/>
                    <div className={"invalid-feedback"}>
                        {erros.titulo}
                    </div>
                </div>
                <div className="mb-3">
                    <label htmlFor="descricao" className="form-label">Descricao</label>
                    <input
                        type="text"
                        className={`form-control ${checkHasError("descricao")}`}
                        id="descricao"
                        aria-describedby="descricaoHelp"
                        placeholder={"Descrição sobre a mensagem"}
                        onChange={(e) => setDescricao(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Tab') {
                                e.preventDefault();
                                const editor = document.querySelector('.ql-editor') as HTMLElement;
                                if (editor) editor.focus();
                            }
                        }}/>
                </div>
                <div className="mb-3">
                    <label htmlFor="conteudo" className="form-label">Mensagem</label>
                    <label className={"text-muted ms-1"}><small>(Obrigatório)</small></label>
                    <div
                        onKeyDownCapture={(e) => {
                            if (e.key === 'Tab' && !(e.target as HTMLElement).classList.contains('ql-editor')) {
                                e.preventDefault();
                                e.stopPropagation();
                                const editor = document.querySelector('.ql-editor') as HTMLElement;
                                if (editor) editor.focus();
                            }
                        }}
                    >
                        <ReactQuill
                            theme="snow"
                            value={conteudo || ''}
                            onChange={setConteudo}
                            modules={modules}
                            placeholder={"Conteúdo da mensagem"}
                            className={checkHasError("conteudo")}
                        />
                    </div>
                    {erros.conteudo && (
                        <div className={"text-danger small mt-1"}>
                            {erros.conteudo}
                        </div>
                    )}
                </div>
                <div className={"d-flex justify-content-end gap-2"}>
                    <button type="submit" disabled={loading} name={"save-and-close"} className="btn btn-primary">Salvar e sair</button>
                    <button type="submit" disabled={loading} className="btn btn-primary">Salvar</button>
                </div>
            </form>
        </>
    )
}

export default CadastrarMensagem;